<div class="mt-3">
    <h5 class="ap-green">{{header1}}</h5>
    <div><label style="color: red">{{header2}}</label>
        <dx-button text="Export All Demands" (onClick)="exportGrids($event)"
        class="ap-green-btn ap-icon float-right"> 
    </dx-button>
    </div>
    <div><label>{{header3}}</label></div>
    <div>  
        <span>{{header4}}</span>
        <span>{{header5}}</span>

        <br />
        <br />
        <h6 class="ap-green">{{header6}}</h6>
        <dx-data-grid #demandCapacitySnapshotGrid style="width: 100%" [dataSource]="demandCapacities[0]"
            [allowColumnReordering]="true" [wordWrapEnabled]="true" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_Snapshot($event)" text="Export to Excel">
                     </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-column-chooser [enabled]="true" [width]="400" [mode]="chooserMode">
            </dxo-column-chooser>
            <dxi-column dataField="plantSitename" sortOrder="asc" caption="Plant Sitename" [width]="250"
                [allowEditing]="false" [groupIndex]="0"></dxi-column>
            <dxi-column dataField="globalIndustrySegment" cssClass="column-group-sub-header"
                caption="Global Industry Segment" [width]="250">
            </dxi-column>
            <dxi-column caption="Total Est. Demand, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="Total" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDgrossN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Winnable" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDnetN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="SAP Sales, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="sapN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Known Gas Users, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="Total from model" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="knUgrossN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Total from CRM Opty" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="knUnetN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="mtDgrossN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>

                <dxi-group-item column="sapN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>


        <h6 class="ap-green mt-3">{{header12}}</h6>
        <dx-data-grid #demandCapacitySnapshotNonAPGrid style="width: 100%" id="demand-capacity-nonap-grid"
            [dataSource]="demandCapacities[0]" [allowColumnReordering]="true" [wordWrapEnabled]="true" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_SnapshotNonAP($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-column-chooser [enabled]="true" [width]="400" [mode]="chooserMode">
            </dxo-column-chooser>
            <dxi-column dataField="plantSitename" sortOrder="asc" caption="Plant Sitename" [width]="250"
                [allowEditing]="false" [groupIndex]="0"></dxi-column>
            <dxi-column caption="" cssClass="column-group-sub-header-information">
                <dxi-column caption="" cssClass="column-group-sub-header-information">
                    <dxi-column dataField="globalIndustrySegment" cssClass="column-group-sub-header"
                        caption="Global Industry Segment" [width]="250">
                    </dxi-column>
                </dxi-column>
            </dxi-column>

            <dxi-column caption="Total Est. Demand, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="Total" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDgrossN2NoAP" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossO2NoAP" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossArNoAP" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossCO2NoAP" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Winnable" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDnetN2NoAP" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetO2NoAP" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetArNoAP" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetCO2NoAP" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="mtDgrossN2NoAP" summaryType="sum" [showInGroupFooter]="false"
                    displayFormat="{0}" [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossO2NoAP" summaryType="sum" [showInGroupFooter]="false"
                    displayFormat="{0}" [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossArNoAP" summaryType="sum" [showInGroupFooter]="false"
                    displayFormat="{0}" [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossCO2NoAP" summaryType="sum" [showInGroupFooter]="false"
                    displayFormat="{0}" [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetN2NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetArNoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetCO2NoAP" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>

        <h6 class="ap-green mt-3">{{header7}}</h6>
        <dx-data-grid style="width: 100%" #demandCapacitySnapshotByCountryGrid [dataSource]="demandCapacities[1]"
            [allowColumnReordering]="true" [wordWrapEnabled]="true" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_SnapshotByCountry($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="15"></dxo-paging>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-column-chooser [enabled]="true" [width]="400" [mode]="chooserMode">
            </dxo-column-chooser>
            <dxi-column dataField="countryID" sortOrder="asc" caption="Customer Country" [width]="200"
                [allowEditing]="false" [groupIndex]="0"></dxi-column>
            <dxi-column dataField="plantSitename" sortOrder="asc" caption="Plant Sitename" [width]="250"
                [allowEditing]="false" [groupIndex]="1"></dxi-column>
            <dxi-column dataField="globalIndustrySegment" cssClass="column-group-sub-header"
                caption="Global Industry Segment" [width]="250">
            </dxi-column>
            <dxi-column caption="Total Est. Demand, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="Total" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDgrossN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDgrossCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Winnable" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="mtDnetN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="mtDnetCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="SAP Sales, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="sapN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="sapCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Known Gas Users, MTD" cssClass="column-group-sub-header" alignment="center">
                <dxi-column caption="Total from model" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="knUgrossN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUgrossCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Total from CRM Opty" cssClass="column-group-sub-header" alignment="center">
                    <dxi-column dataField="knUnetN2" cssClass="column-group-sub-header" caption="N2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetO2" cssClass="column-group-sub-header" caption="O2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetAr" cssClass="column-group-sub-header" caption="Ar">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="knUnetCO2" cssClass="column-group-sub-header" caption="CO2">
                        <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                    </dxi-column>
                </dxi-column>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="mtDgrossN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDgrossCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="mtDnetCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>

                <dxi-group-item column="sapN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="sapCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>


                <dxi-group-item column="knUgrossN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUgrossCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>


                <dxi-group-item column="knUnetN2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetAr" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="knUnetCO2" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>


        <h6 class="ap-green mt-3">{{header8}}</h6>
        <div>
            {{header9}}
        </div>
        <br />
        <h6 class="ap-green">{{header10}}</h6>
        <dx-data-grid style="width: 100%" #demandCapacityByPlantGrid [dataSource]="capacityByPlants"
            [allowColumnReordering]="true" [wordWrapEnabled]="true" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_SnapshotByPlant($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-column-chooser [enabled]="true" [width]="400" [mode]="chooserMode">
            </dxo-column-chooser>
            <dxi-column dataField="companyName" sortOrder="asc" caption="Company" [width]="250" [allowEditing]="false"
                [groupIndex]="0">
            </dxi-column>
            <dxi-column dataField="siteName" cssClass="column-group-sub-header" caption="Site Name">
            </dxi-column>
            <dxi-column dataField="milesToAP" cssClass="column-group-sub-header" caption="Miles To AP Plant">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="capacity" cssClass="column-group-sub-header" caption="Nameplate* Capacity">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="capFrac" cssClass="column-group-sub-header" caption="Relevant* Capacity">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="capacity" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="capFrac" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-total-item displayFormat="Total: {0}" column="capFrac" [valueFormat]="{type:'fixedPoint',precision:1}" summaryType="sum">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-total-item>
            </dxo-summary>
        </dx-data-grid>

        <h6 class="ap-green mt-3">{{header11}}</h6>
        <dx-data-grid style="width: 100%" #demandCapacityByPlantExclusiveGrid [dataSource]="exclusiveCapacityByPlants"
            [allowColumnReordering]="true" [wordWrapEnabled]="true" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn"
                        (onClick)="exportExcel_SnapshotByPlantExclusive($event)" text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-column-chooser [enabled]="true" [width]="400" [mode]="chooserMode">
            </dxo-column-chooser>
            <dxi-column dataField="refSiteName" sortOrder="asc" caption="Around SiteName" [width]="250"
                [allowEditing]="false" [groupIndex]="0">
            </dxi-column>
            <dxi-column dataField="companyName" cssClass="column-group-sub-header" caption="Company" [groupIndex]="1">
            </dxi-column>
            <dxi-column dataField="siteName" cssClass="column-group-sub-header" caption="Site Name">
            </dxi-column>
            <dxi-column dataField="milesToAP" cssClass="column-group-sub-header" caption="Miles To AP Plant">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="capacity" cssClass="column-group-sub-header" caption="Nameplate* Capacity">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="capFrac" cssClass="column-group-sub-header" caption="Relevant* Capacity">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxo-summary>
                <dxi-group-item column="capacity" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
                <dxi-group-item column="capFrac" summaryType="sum" [showInGroupFooter]="false" displayFormat="{0}"
                    [valueFormat]="{type:'fixedPoint',precision:1}" [alignByColumn]="true">
                    <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
                </dxi-group-item>
            </dxo-summary>
        </dx-data-grid>

    </div>
</div>